// Generated taxonomy data
export const taxonomyTree = {
    "Adhesives": {
      "featuredBrands": [
        { "id": 300, "name": "Pro Tapes" },
        { "id": 9, "name": "Aleene's" },
        { "id": 116, "name": "Elmer's" },
        { "id": 1473, "name": "The Gorilla Glue Company" },
        { "id": 526, "name": "Surebonder" },
        { "id": 215, "name": "Lineco" },
        { "id": 219, "name": "Loctite" },
        { "id": 1092, "name": "Yes!" },
        { "id": 514, "name": "HeadLine" },
        { "id": 42, "name": "Best-Test" }
      ],
      "Adhesive Dispensers": null,
      "Adhesive Removers": null,
      "Adhesive Sheets, Strips, & Dots": null,
      "Glue": {
        "Cement": null,
        "Children's Glue": null,
        "Craft & Household Glue": null,
        "Epoxy & Extra Strength Glue": null,
        "Fabric Glue": null,
        "Glue Guns": null,
        "Glue Sticks": null,
        "Paste": null,
        "Wood Glue": null
      },
      "Hook & Loop": null,
      "Magnets & Magnetic Sheets": null,
      "Mounting Adhesives": {
        "Dry Mounting": null,
        "Mounting Sprays": null,
        "Mounting Tapes": null,
        "Tabs, Sheets, & Squares": null
      },
      "Spray Adhesives": null,
      "Tape": {
        "Archival & Book Tape": null,
        "Artist's Tape": null,
        "Decorative Tape": null,
        "Double Coated Tape": null,
        "Drafting Tape": null,
        "Duct Tape": null,
        "Foam Tape": null,
        "Gaffer Tape": null,
        "Masking Tape": null,
        "Packing & Repair Tape": null,
        "Transparent Tape": null
      },
      "Wax": null
    },
    "Airbrushing": {
      "featuredBrands": [
        { "id": 185, "name": "Iwata" },
        { "id": 86, "name": "Createx" },
        { "id": 269, "name": "Paasche" },
        { "id": 156, "name": "Grafix" },
        { "id": 188, "name": "Jacquard" },
        { "id": 352, "name": "Silentaire" },
        { "id": 1086, "name": "Artool" },
        { "id": 217, "name": "Liquitex" },
        { "id": 277, "name": "Pebeo" },
        { "id": 1978, "name": "Grex" }
      ],
      "Airbrush Mediums": null,
      "Airbrush Paints": null,
      "Airbrush Parts": null,
      "Airbrush Storage": null,
      "Airbrush Templates": null,
      "Airbrushes": null,
      "Books & Media": null,
      "Cleaning & Maintenance": null,
      "Compressors & Propellants": null,
      "Frisket": null,
      "Sets & Kits": null
    },
    "Architecture & Drafting": {
      "featuredBrands": [
        { "id": 43, "name": "Bienfang" },
        { "id": 1249, "name": "Borden & Riley" },
        { "id": 156, "name": "Grafix" },
        { "id": 72, "name": "Clearprint" },
        { "id": 1502, "name": "Ludwig" },
        { "id": 270, "name": "Pacific Arc" },
        { "id": 434, "name": "Rapidesign" },
        { "id": 12, "name": "Alumicolor" },
        { "id": 1387, "name": "Westcott" },
        { "id": 515, "name": "Staedtler" }
      ],
      "Drafting": {
        "Films": {
          "Film Pads": null,
          "Film Rolls": null,
          "Film Sheets": null
        },
        "Lettering Guides": null,
        "Paper": {
          "Paper Pads": null,
          "Paper Rolls": null,
          "Paper Sheets": null
        },
        "Paper & Films": null,
        "Protractors & Compasses": null,
        "Scales & Rulers": null,
        "Sets & Kits": null,
        "T-Squares": null,
        "Templates": null,
        "Tools & Accessories": null,
        "Triangles": null
      }
    },
    "Books & Media": {
      "featuredBrands": [
        { "id": 107, "name": "Dover" },
        { "id": 507, "name": "Klutz" },
        { "id": 1255, "name": "Pomegranate" },
        { "id": 1231, "name": "Workman Publishing" },
        { "id": 1110, "name": "Tuttle" },
        { "id": 1167, "name": "Search Press" },
        { "id": 1664, "name": "Arcturus Publishing" },
        { "id": 1324, "name": "Design Originals" },
        { "id": 405, "name": "Walter Foster" }
        // { "id": 2445, "name": "Sourcebooks" }
      ],
      "Activity Books": {
        "Activities & Projects": null,
        "Art Cards & Post Cards": null,
        "Holidays & Parties": null,
        "Mazes": null,
        "Paper Dolls": null,
        "Puzzles & Games": null,
        "Stencils": null,
        "Sticker Books": null,
        "Tattoo Books": null
      },
      "Airbrush": null,
      "Architecture": null,
      "Art Reference": {
        "Artist Biographies": null,
        "Artist Portfolios": null,
        "Business of Art": null,
        "Color Theory": null,
        "Dictionaries & Encyclopedias": null
      },
      "Ceramics": null,
      "Clip Art": {
        "Floral Designs": null
      },
      "Coloring Books": {
        "Animals": null,
        "Children's Favorites": null,
        "Designs & Motifs": null,
        "Famous Art Works": null,
        "Historical": null,
        "People & Places": null,
        "Plants & Flowers": null,
        "Stained Glass": null
      },
      "Craft & Hobby": {
        "General Crafting": null,
        "Gold Leaf": null,
        "Jewelry Making & Beading": null,
        "Leather Working": null,
        "Lettering & Calligraphy": null,
        "Mosaic & Glass Art": null,
        "Origami": null,
        "Papercraft": null,
        "Polymer & Hobby Clay": null,
        "Woodcraft": null
      },
      "Drawing": {
        "Animals": null,
        "Cartooning & Animation": null,
        "General Drawing Technique": null,
        "Human Figure & Portraiture": null,
        "Land & Seascapes": null,
        "Manga & Comics": null,
        "Perspective": null
      },
      "Fabric & Fashion Design": null,
      "Furniture & Home Decorating": null,
      "Graphic Design": null,
      "Painting": {
        "Acrylic Painting": null,
        "General Painting Techniques": null,
        "Human Figure & Portraiture": null,
        "Land & Seascapes": null,
        "Mixed Media": null,
        "Oil Painting": null,
        "Watercolor Painting": null
      },
      "Pastel": null,
      "Printmaking": null,
      "Videos & DVDs": null
    },
    "Brushes": {
      "featuredBrands": [
        { "id": 297, "name": "Princeton" },
        { "id": 354, "name": "Silver Brush" },
        { "id": 111, "name": "Dynasty" },
        { "id": 413, "name": "Winsor & Newton" },
        { "id": 1404, "name": "Escoda" },
        { "id": 95, "name": "Daler-Rowney" },
        { "id": 324, "name": "Royal & Langnickel" },
        { "id": 314, "name": "Robert Simmons" },
        { "id": 421, "name": "Yasutomo" },
        { "id": 217, "name": "Liquitex" }
      ],
      "Acrylic Brushes": {
        "Angular": null,
        "Bright": null,
        "Brush Sets": null,
        "Fan": null,
        "Filbert": null,
        "Flat": null,
        "Gesso": null,
        "Liner": null,
        "Oil & Acrylic Brushes": null,
        "Round": null,
        "Wash & Mop": null
      },
      "Brush Sets": {
        "Acrylic": null,
        "Classroom": null,
        "Craft & Hobby": null,
        "Watercolor": null
      },
      "Cleaning": null,
      "Craft & Hobby Brushes": {
        "Brush Sets": null,
        "Detail": null,
        "Flat": null,
        "Wash & Mop": null
      },
      "Decorative Brushes": null,
      "Home Decor": null,
      "Kid's Brushes": null,
      "Lettering & Sign Brushes": null,
      "Oil and Acrylic": null,
      "Oil Brushes": {
        "Bright": null,
        "Fan": null,
        "Filbert": null,
        "Flat": null,
        "Round": null
      },
      "Stencil & Utility Brushes": null,
      "Storage": null,
      "Watercolor Brushes": {
        "Angular": null,
        "Bamboo": null,
        "Brush Sets": null,
        "Detail": null,
        "Filbert": null,
        "Flat": null,
        "Hake": null,
        "Other": null,
        "Round": null,
        "Shader": null,
        "Wash & Mop": null
      }
    },
    "Canvas": {
      "featuredBrands": [
        { "id": 136, "name": "Fredrix" },
        { "id": 413, "name": "Winsor & Newton" },
        { "id": 1087, "name": "Masterpiece Artist Canvas" },
        { "id": 217, "name": "Liquitex" },
        { "id": 369, "name": "Strathmore" },
        { "id": 41, "name": "Best" },
        { "id": 95, "name": "Daler-Rowney" },
        { "id": 18, "name": "Ampersand" },
        { "id": 1232, "name": "American Easel" },
        { "id": 155, "name": "Golden" }
      ],
      "Accessories": null,
      "Canvas Boards": null,
      "Canvas Paper & Pads": null,
      "Priming & Sizing": null,
      "Rolled Canvas": null,
      "Stretched Canvas": null,
      "Stretching": null
    },
    "Ceramics": {
      "featuredBrands": [
        { "id": 15, "name": "Amaco" },
        { "id": 464, "name": "Jack Richeson" },
        { "id": 1406, "name": "Das" },
        { "id": 398, "name": "Van Aken" },
        { "id": 8, "name": "Activa Products" },
        { "id": 277, "name": "Pebeo" },
        { "id": 551, "name": "National Artcraft" },
        { "id": 98, "name": "DecoArt" },
        { "id": 1829, "name": "The Ceramic Shop" },
        { "id": null, "name": "" }
      ],
      "Clay": null,
      "Cones & Stilts": null,
      "Glaze & Under Glaze": null,
      "Materials & Supplies": null,
      "Tools": null
    },
    "Crafts": {
      "featuredBrands": [
        { "id": 307, "name": "Ranger" },
        { "id": 248, "name": "Midwest" },
        { "id": 206, "name": "Krylon" },
        { "id": 188, "name": "Jacquard" },
        { "id": 341, "name": "Sculpey" },
        { "id": 215, "name": "Lineco" },
        { "id": 1303, "name": "FloraCraft" },
        { "id": 288, "name": "Plaid" },
        { "id": 8, "name": "Activa Products" },
        { "id": 535, "name": "Mona Lisa" }
      ],
      "Book Binding": null,
      "Candle Making": null,
      "Decorative Painting": {
        "Brushes": null,
        "Craft Acrylics": null,
        "Fabric Paint": null,
        "Faux Finishing": null,
        "Glazes & Mediums": null,
        "Sealers & Finishers": null,
        "Spray Paints": null,
        "Tools": null
      },
      "Glitter": {
        "Adhesives": null,
        "Glitter": null,
        "Glitter Paint & Pens": null,
        "Tools": null
      },
      "Gold Leaf": {
        "Gold Leaf & Powders": null,
        "Sets & Kits": null,
        "Sizing & Sealers": null,
        "Tools": null
      },
      "Jewelry Making": {
        "Beads & Beading": null,
        "Jewelry Making Materials": null,
        "Molds": null,
        "Tools": null
      },
      "Leather Crafting": null,
      "Metal Tooling": null,
      "Model Making": {
        "Balsa & Basswood": null,
        "Foam": null,
        "Metals": null,
        "Model Landscaping": null,
        "Plastic Sheets": null,
        "Tools": null
      },
      "Papermaking": {
        "Supplies": null
      },
      "Papier Mache & Decoupage": null,
      "Polymer & Hobby Clay": {
        "Finishes": null,
        "Hobby Clay": null,
        "Molds": null,
        "Polymer Clay": null,
        "Sets & Kits": null,
        "Tools": null
      },
      "Sand Art": null,
      "Scratch Art": null,
      "Sealing Wax": null,
      "Stamps & Embossing": {
        "Accessories": null,
        "Inks & Powders": null,
        "Patterns": null,
        "Sets": null,
        "Stamp Pads": null,
        "Tools": null
      },
      "Stenciling": {
        "Decorative Stencils": null,
        "Stenciling Paints": null,
        "Tools": null
      },
      "Stickers": null,
      "Textiles & Dyes": {
        "Batik": null,
        "Dyes": null,
        "Fabric": null,
        "Fabric Paints": null,
        "Markers": null,
        "Miscellaneous": null
      },
      "Wood": null
    },
    "Display & Presentation": {
      "featuredBrands": [
        // { "id": 2456, "name": "3A Composites" },
        { "id": 184, "name": "Itoya" },
        { "id": 90, "name": "Crescent" },
        { "id": 369, "name": "Strathmore" },
        { "id": 215, "name": "Lineco" },
        { "id": 1451, "name": "Filexec" },
        { "id": 475, "name": "Prat" },
        { "id": 1171, "name": "Duro" },
        { "id": 2197, "name": "Stanrite" },
        { "id": 32, "name": "Bainbridge" }
      ],
      "Accessories": null,
      "Binders & Display Books": null,
      "Bulletin Boards": null,
      "Chalk & Marker Boards": null,
      "Display Boards": {
        "Foam Boards": null,
        "Mat Boards": null,
        "Mounting Boards": null,
        "Poster Boards": null
      },
      "Display Easels": null,
      "Portfolios": null,
      "Presentation Cases": null,
      "Project Display": null,
      "Refill Pages": null,
      "Sign Supplies": null
    },
    "Drawing & Illustration": {
      "featuredBrands": [
        { "id": 237, "name": "Marvy Uchida" },
        { "id": 331, "name": "Sakura" },
        { "id": 298, "name": "Prismacolor" },
        { "id": 122, "name": "Faber-Castell" },
        { "id": 279, "name": "Pentel" },
        { "id": 515, "name": "Staedtler" },
        { "id": 101, "name": "Derwent" },
        { "id": 2044, "name": "uni POSCA" },
        { "id": 147, "name": "General's" },
        { "id": 544, "name": "Copic" }
      ],
      "Accessories": {
        "Blenders & Tortillions": null,
        "Correction Supplies": null,
        "Fixatives": null,
        "Holders & Grips": null
      },
      "Artist Chalk": null,
      "Artist Crayons": null,
      "Charcoal": null,
      "Drawing & Lettering Aids": {
        "Curves": null,
        "Lettering Guides": null,
        "Protractors & Compasses": null,
        "Scales & Rulers": null,
        "Stencils": null,
        "Templates": null
      },
      "Graphite": null,
      "Ink": {
        "Accessories": null,
        "Calligraphy Inks": null,
        "Drawing Inks": null,
        "India Inks": null,
        "Sumi Ink & Supplies": null,
        "Technical Inks": null
      },
      "Leads": null,
      "Markers": {
        "Craft Markers": null,
        "Dry Erase & Overhead Markers": null,
        "Fabric Markers": null,
        "Glass Markers": null,
        "Highlighters": null,
        "Kids' Markers": null,
        "Lettering": null,
        "Non-permanent Markers": null,
        "Paint Pens & Opaque Markers": null,
        "Permanent Markers": null,
        "Professional Art Markers": null,
        "Storage": null
      },
      "Pastels": {
        "Hard Pastels": null,
        "Oil Pastels": null,
        "Pastel Pencils": null,
        "Soft Pastels": null
      },
      "Pencils": {
        "All Surface": null,
        "Colored Pencils": null,
        "Drawing & Sketching Pencils": null,
        "Erasers": null,
        "Kids' Pencils": null,
        "Mechanical Pencils & Leads": null,
        "Other Pencils": null,
        "Sharpeners": null
      },
      "Pens": {
        "General Purpose Pens": {
          "Ballpoint Pens": null,
          "Felt Tip Pens": null,
          "Gel Pens": null,
          "Rollerball Pens": null
        },
        "Lettering & Calligraphy Pens": {
          "Accessories": null,
          "Cartridge Pens": null,
          "Dip Pens": null,
          "Felt Pens": null,
          "Sets & Kits": null
        },
        "Pen Cleaners": null,
        "Sketching Pens": null,
        "Specialty Pens": {
          "Brush Pens": null,
          "Fine Writing Pens": null,
          "Fountain Pens": null,
          "Plotter Pens": null,
          "Security Pens": null
        },
        "Technical Pens": null
      },
      "Storage": null
    },
    "Easels": {
      "featuredBrands": [
        { "id": 1780, "name": "Green Panda" },
        { "id": 464, "name": "Jack Richeson" },
        { "id": 41, "name": "Best" },
        { "id": 370, "name": "Studio Designs" },
        { "id": 2197, "name": "Stanrite" },
        { "id": 270, "name": "Pacific Arc" },
        { "id": 484, "name": "Tripar International" },
        { "id": 1288, "name": "Melissa & Doug" },
        { "id": 407, "name": "Martin/F. Weber" },
        { "id": 136, "name": "Fredrix" }
      ],
      "Display Easels": null,
      "Field & Travel Easels": null,
      "Kids' Easels": null,
      "Studio Easels": null,
      "Table Top Easels": null
    },
    "Framing": {
      "featuredBrands": [
        { "id": 244, "name": "MCS" },
        { "id": 260, "name": "Nielsen Bainbridge" },
        { "id": 18, "name": "Ampersand" },
        { "id": 134, "name": "Framatic" },
        { "id": 90, "name": "Crescent" },
        { "id": 221, "name": "Logan Graphic Products" },
        { "id": 2275, "name": "Ook" },
        { "id": 1165, "name": "Callen Crafters" },
        { "id": 1607, "name": "Malden" },
        { "id": 300, "name": "Pro Tapes" }
      ],
      "Frames": {
        "Acrylic Frames": null,
        "Aluminum & Metal Frames": null,
        "Kits": null,
        "Wood Frames": null
      },
      "Hangers": {
        "Adhesives": null,
        "Fasteners & Picture Wire": null
      },
      "Mat Boards": null,
      "Mat Cutters": null,
      "Mounting Adhesives": {
        "Mounting Tapes": null,
        "Tabs, Sheets, & Squares": null
      },
      "Pre-Cut Mats": null,
      "Tools & Accessories": null
    },
    "Furniture": {
      "featuredBrands": [
        { "id": 370, "name": "Studio Designs" },
        { "id": 464, "name": "Jack Richeson" },
        { "id": 270, "name": "Pacific Arc" },
        { "id": 1115, "name": "Daylight" },
        { "id": 167, "name": "Helix" },
        { "id": 28, "name": "Artograph" },
        { "id": 1114, "name": "Daylight Company" },
        { "id": 2197, "name": "Stanrite" },
        { "id": 202, "name": "Koh-I-Noor" },
        { "id": 156, "name": "Grafix" }
      ],
      "Accessories": null,
      "Chairs & Stools": null,
      "Lamps": {
        "Bulbs & Accessories": null,
        "Easel Lamps": null,
        "Floor Lamps": null,
        "Magnifying Lamps": null,
        "Photo Lights": null,
        "Table Lamps": null
      },
      "Studio Organizers": {
        "Cabinets": null,
        "Print Racks": null,
        "Taborets": null
      },
      "Tables & Drawing Boards": {
        "Art Tables": null,
        "Drawing Boards": null
      }
    },
    "Glass & Tile Art": {
      "featuredBrands": [
        { "id": 21, "name": "Armour" },
        { "id": 277, "name": "Pebeo" },
        { "id": 454, "name": "Milestones" },
        { "id": 288, "name": "Plaid" },
        { "id": 253, "name": "Mosaic Mercantile" },
        { "id": 1328, "name": "Diamond Tech" },
        { "id": 1061, "name": "Jennifer's Mosaics" },
        { "id": 1333, "name": "Cousin" },
        { "id": 89, "name": "Creativity For Kids" },
        { "id": 206, "name": "Krylon" }
      ],
      "Etching": null,
      "Mosaic Supplies": {
        "Accessories & Tools": null,
        "Kits": null,
        "Mosaic Tiles & Stones": null
      },
      "Painting": null
    },
    "Kids' Korner": {
      "featuredBrands": [
        { "id": 84, "name": "Crayola" },
        { "id": 122, "name": "Faber-Castell" },
        { "id": 1186, "name": "Chroma Inc." },
        { "id": 89, "name": "Creativity For Kids" },
        { "id": 1542, "name": "Schleich" },
        { "id": 1494, "name": "Paper House Productions" },
        { "id": 461, "name": "Snazaroo" },
        { "id": 295, "name": "Prang" },
        { "id": 324, "name": "Royal & Langnickel" },
        { "id": 507, "name": "Klutz" }
      ],
      "Animals": null,
      "Beading & Jewelry": null,
      "Books": {
        "Activity Books": null,
        "Educational Books": null
      },
      "Construction": null,
      "Cool Accessories": null,
      "Crafts": {
        "Animal Crafts": null,
        "Classic Crafts": null,
        "Decorative Crafts": null,
        "Fabric Crafts": null,
        "Garden & Outdoor Crafts": null,
        "General Craft Supplies": null,
        "Miscellaneous Crafts": null
      },
      "Drawing": {
        "Chalk": null,
        "Crayons": null,
        "Drawing Paper": null,
        "Markers": null,
        "Pencils": null,
        "Sets & Kits": null
      },
      "Furniture": null,
      "Hair & Body Art": null,
      "Painting": {
        "Accessories": null,
        "Brushes": null,
        "Paint by Numbers": null,
        "Paints": null,
        "Paper": null,
        "Sets & Kits": null
      },
      "Room D\u00e9cor": null,
      "Science & Nature": null,
      "Sculpting & Pottery": null,
      "Shrink Art": null,
      "Sticker Collecting": {
        "Sticker Books": null,
        "Stickers": null
      }
    },
    "Painting": {
      "featuredBrands": [
        { "id": 413, "name": "Winsor & Newton" },
        { "id": 217, "name": "Liquitex" },
        { "id": 155, "name": "Golden" },
        { "id": 1390, "name": "Amsterdam" },
        { "id": 1797, "name": "Daniel Smith" },
        { "id": 462, "name": "Holbein" },
        { "id": 163, "name": "Grumbacher" },
        { "id": 1456, "name": "MTN" },
        { "id": 1186, "name": "Chroma Inc." },
        { "id": 464, "name": "Jack Richeson" }
      ],
      "Acrylics": {
        "Gels & Mediums": null,
        "Gesso": null,
        "Paints": {
          "Paint Markers": null
        },
        "Sets & Kits": null
      },
      "Cleaning": {
        "Aprons & Drop Cloths": null,
        "Brush Cleaners": null,
        "Hand Cleaning": null,
        "Painting Restoration": null,
        "Wipes & Cloths": null
      },
      "Decorative Painting": {
        "Craft Acrylics": null,
        "Fabric Paint": null,
        "Faux Finishing": null,
        "Glazes & Mediums": null,
        "Leather Paint": null,
        "Sealers & Finishers": null,
        "Spray Paints": null
      },
      "Enamels": null,
      "Encaustic": {
        "Encaustic Mediums": null,
        "Encaustic Paints": null,
        "Encaustic Tools": null
      },
      "Face & Body Paints": null,
      "Kids' Paints": null,
      "Oil Paints": {
        "Mediums": null,
        "Paint Sticks": null,
        "Paints": null,
        "Sets & Kits": null,
        "Solvents & Thinners": null
      },
      "Paint by Numbers": null,
      "Palettes": {
        "Covered Palettes": null,
        "Glass & Porcelain Palettes": null,
        "Mixing Dishes": null,
        "Oil & Acrylic Palettes": null,
        "Palette Paper & Pads": null,
        "Watercolor Palettes": null,
        "Wood Palettes": null
      },
      "Pigments": null,
      "Storage": null,
      "Tempera": null,
      "Tools": {
        "Color Wheels & Guides": null,
        "Mannequins": null,
        "Other": null,
        "Palette Knives": null,
        "Sponges": null
      },
      "Varnishes & Sprays": {
        "Clear": null,
        "Damar": null,
        "Gloss": null,
        "Matte": null,
        "Re-touching": null,
        "Satin": null
      },
      "Watercolors": {
        "Crayons & Pencils": null,
        "Frisket": null,
        "Gouache & Opaque Watercolors": null,
        "Mediums": null,
        "Paints": null,
        "Sets & Kits": null
      }
    },
    "Paper & Boards": {
      "featuredBrands": [
        { "id": 369, "name": "Strathmore" },
        { "id": 62, "name": "Canson" },
        { "id": 93, "name": "Arches" },
        { "id": 90, "name": "Crescent" },
        { "id": 18, "name": "Ampersand" },
        // { "id": 2198, "name": "Fluid" },
        { "id": 123, "name": "Fabriano" },
        { "id": 271, "name": "Pacon" },
        { "id": 1472, "name": "Moleskine" },
        { "id": 43, "name": "Bienfang" }
      ],
      "Art & Illustration": {
        "Artist Trading Cards": null,
        "Bristol Paper": {
          "Bound Books & Journals": null,
          "Bristol Pads": null,
          "Bristol Sheets": null
        },
        "Canvas Boards": null,
        "Canvas Paper": null,
        "Charcoal & Pastel Paper": {
          "Charcoal & Pastel Pads": null,
          "Charcoal & Pastel Sheets": null
        },
        "Clay Boards": null,
        "Drawing Paper": {
          "Drawing Bound Books & Journals": null,
          "Drawing Pads": null,
          "Drawing Paper Sheets": null,
          "Drawing Rolls": null
        },
        "Graphite & Transfer Paper": null,
        "Greeting Cards": null,
        "Illustration Boards": null,
        "Interleaving": null,
        "International & Exotic Paper": null,
        "Marker & Layout": {
          "Pads": null
        },
        "Mix Media": {
          "Mix Media Bound Books & Journals": null,
          "Mix Media Pads": null
        },
        "Oil Paper": {
          "Oil Paper Pads": null,
          "Oil Paper Sheets": null
        },
        "Pastel Boards": null,
        "Printmaking": null,
        "Scratch Boards": null,
        "Sketch Paper": {
          "Sketch Bound Books & Journals": null,
          "Sketch Pads": null,
          "Sketch Paper Rolls": null,
          "Sketch Paper Sheets": null
        },
        "Sumi": null,
        "Tracing & Graph Paper": {
          "Acetate": null,
          "Tracing Paper Pads": null
        },
        "Watercolor Paper": {
          "Watercolor Blocks": null,
          "Watercolor Pads & Journals": null,
          "Watercolor Rolls": null,
          "Watercolor Sheets": null
        },
        "Zentangle & Pattern": null
      },
      "Art Panels": null,
      "Boards": null,
      "Framing & Display": {
        "Cork Boards & Rolls": null,
        "Corrugated Boards": null,
        "Display Boards": {
          "Mat Boards": null,
          "Poster Boards": null
        }
      },
      "Hobby & Decorative Paper": {
        "Construction Paper": {
          "Packs": null,
          "Sheets": null
        },
        "Craft Paper": {
          "Color Paper": null,
          "Decorative Film": null,
          "Metallic Paper": null,
          "Origami Paper": null,
          "Rolls": null,
          "Textured Paper": null,
          "Tissue Paper": null
        },
        "Decorative": null,
        "Wrapping Paper": null
      },
      "Writing & Printer Paper": {
        "Calligraphy Paper": null,
        "Journals & Notebooks": null,
        "Printer & Copier Paper": {
          "Inkjet Printer Paper": null
        },
        "Stationery Paper": null
      }
    },
    "Photography": {
      "featuredBrands": [
        { "id": 1160, "name": "Savage Universal" },
        { "id": 28, "name": "Artograph" },
        { "id": 1407, "name": "ClearBags" },
        { "id": 215, "name": "Lineco" },
        { "id": 184, "name": "Itoya" },
        { "id": 81, "name": "Con-Tact Brand" },
        { "id": 62, "name": "Canson" },
        { "id": null, "name": "" },
        { "id": null, "name": "" },
        { "id": null, "name": "" }
      ],
      "Backdrops": null,
      "Lightboxes": null,
      "Presentation & Storage": null
    },
    "Printmaking": {
      "featuredBrands": [
        { "id": 358, "name": "Speedball" },
        { "id": 394, "name": "Ulano" },
        { "id": 464, "name": "Jack Richeson" },
        { "id": 1436, "name": "U J Ramelson" },
        { "id": 1707, "name": "Akua" },
        { "id": 1411, "name": "Essdee" },
        { "id": 157, "name": "Graphic Chemical" },
        { "id": 307, "name": "Ranger" },
        { "id": 340, "name": "Screen Grafex" },
        { "id": 86, "name": "Createx" }
      ],
      "Brayers": null,
      "Etching & Intaglio": null,
      "Linoleum & Wood Block Printing": {
        "Blocks & Surfaces": null,
        "Inks & Mediums": null,
        "Sets & Kits": null,
        "Tools & Accessories": null
      },
      "Silk Screen & Lithography": {
        "Accessories": null,
        "Inks & Mediums": null,
        "Screens": null,
        "Sets & Kits": null,
        "Squeegees": null
      }
    },
    "Safety & Cleaning": {
      "featuredBrands": [
        { "id": 1482, "name": "Mark Richards Enterprises" },
        { "id": 1470, "name": "Canvas Corp" },
        { "id": 86, "name": "Createx" },
        { "id": 175, "name": "Hygloss" },
        { "id": 1328, "name": "Diamond Tech" },
        { "id": 1488, "name": "Uline" },
        { "id": 358, "name": "Speedball" },
        { "id": 1113, "name": "Linzer" },
        { "id": 1386, "name": "KALT" },
        { "id": 124, "name": "Falcon Safety" }
      ],
      "Adhesive Removers": null,
      "Airbrush Cleaners": null,
      "Aprons & Drop Cloths": null,
      "Gloves": null,
      "Masks & Goggles": null,
      "Pen Cleaners": null,
      "Wipes, Dusters, & Cloths": null
    },
    "Scrapbooking": {
      "featuredBrands": [
        { "id": 1512, "name": "Sticko" },
        { "id": 1427, "name": "Tim Holtz" },
        { "id": 1142, "name": "Therm O Web" },
        { "id": 122, "name": "Faber-Castell" },
        { "id": 1679, "name": "We R Memory Keepers" },
        { "id": 2045, "name": "Creative Arts" },
        { "id": 2017, "name": "Tonic Studios" },
        { "id": 128, "name": "Fiskars" },
        { "id": 307, "name": "Ranger" },
        { "id": 37, "name": "Beacon" }
      ],
      "Accessories": null,
      "Adhesives": null,
      "Albums & Refills": null,
      "Cards & Invitations": null,
      "Embellishments": null,
      "Embossing & Stamps": {
        "Stamp Pads": null
      },
      "Paints & Finishes": null,
      "Paper & Cardstock": null,
      "Pens & Markers": null,
      "Stickers & Rub Ons": {
        "Rub Ons": null,
        "Sticker Books": null,
        "Stickers": null
      },
      "Storage": null,
      "Tools": {
        "Embellishment Tools": null,
        "Punches": null,
        "Trimming & Tracing Tools": null
      }
    },
    "Sculpting": {
      "featuredBrands": [
        { "id": 1108, "name": "Smooth-On" },
        { "id": 1406, "name": "Das" },
        { "id": 8, "name": "Activa Products" },
        { "id": 464, "name": "Jack Richeson" },
        { "id": 1150, "name": "Mann Release Technologies" },
        { "id": 13, "name": "Alumilite" },
        { "id": 1746, "name": "Castin' Craft" },
        { "id": 1428, "name": "Skullduggery" },
        { "id": 277, "name": "Pebeo" },
        { "id": 15, "name": "Amaco" }
      ],
      "Clays": {
        "Hardening Clays": null
      },
      "Modeling Frames & Wires": null,
      "Modeling Tools": null,
      "Modeling Wax": null,
      "Mold Making": {
        "Casting & Plaster Molds": null,
        "Casting Resins": null,
        "Mixing Cups": null,
        "Molding Compounds": null,
        "Releases": null
      },
      "Wood Carving Tools": null
    },
    "Storage": {
      "featuredBrands": [
        // { "id": 2279, "name": "PuniLabo" },
        { "id": 22, "name": "ArtBin" },
        { "id": 1916, "name": "Deflecto" },
        { "id": 215, "name": "Lineco" },
        { "id": 407, "name": "Martin/F. Weber" },
        { "id": 184, "name": "Itoya" },
        { "id": 1481, "name": "Knock Knock" },
        { "id": 1096, "name": "Global Art" },
        { "id": 544, "name": "Copic" },
        { "id": 307, "name": "Ranger" }
      ],
      "Caddies": null,
      "Filing Solutions": null,
      "Paint": null,
      "Pens, Pencils, & Marker Storage": null,
      "Photography Storage": {
        "Photo Books & Albums": null
      },
      "Scrapbook Storage": null,
      "Studio Organizers": null,
      "Tool Bins & Sketch Boxes": null
    },
    "Tools": {
      "featuredBrands": [
        { "id": 418, "name": "X-Acto" },
        { "id": 1236, "name": "Excel" },
        { "id": 270, "name": "Pacific Arc" },
        { "id": 128, "name": "Fiskars" },
        { "id": 266, "name": "Olfa" },
        { "id": 28, "name": "Artograph" },
        { "id": 472, "name": "McGill" },
        { "id": 427, "name": "Dahle" },
        { "id": 2017, "name": "Tonic Studios" },
        { "id": 237, "name": "Marvy Uchida" }
      ],
      "Blades & Knives": {
        "Accessories": null,
        "Cutting Mats": null,
        "Precision & Pen Knives": null,
        "Replacement Blades": null,
        "Sets & Kits": null,
        "Utility Knives": null
      },
      "Book Lights": null,
      "Light Boxes & Projectors": {
        "Accessories": null,
        "Light Boxes": null,
        "Projectors": null
      },
      "Magnifiers": null,
      "Paper Trimmers": null,
      "Punches": null,
      "Sanding": null,
      "Scissors": null,
      "Staplers & Fasteners": null
    },
    "Transporting": {
      "featuredBrands": [
        { "id": 270, "name": "Pacific Arc" },
        { "id": 184, "name": "Itoya" },
        { "id": 1698, "name": "Krystal Seal" },
        { "id": 226, "name": "Maco" },
        { "id": 1488, "name": "Uline" },
        { "id": 66, "name": "Chartpak" },
        // { "id": 2217, "name": "IF USA" },
        { "id": 1772, "name": "Star Products" },
        { "id": 1482, "name": "Mark Richards Enterprises" },
        { "id": 1470, "name": "Canvas Corp" }
      ],
      "Carry Bags": null,
      "Cases & Pouches": null,
      "Labels & Seals": null,
      "Packing & Shipping Material": null,
      "Tubes": null
    }
  }
  